import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "max-w-xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Timezone", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton-loading h-9.5 mt-3 mb-4" }, null, -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mt-4" }

import { computed, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { required } from '@vuelidate/validators';
import {
	UiForm,
	UiSelect,
	UiButton,
	UiCardDivider,
	UiCard,
	SvgIcon,
	UiAudio,
	useLoading,
	useForm
} from '@/ui-kit';
import { Nullable } from '@/utils';
import { useDays, usePhoneNumbers } from '../composition';
import EditPhoneNumberBusinessHoursDialog from '../components/EditPhoneNumberBusinessHoursDialog.vue';
import PhoneDetailsPanel from './PhoneDetailsPanel.vue';
import { BusinessDay } from '../types';
import { usePhoneNumberDetails } from '../composition/use-phone-number-details';
import { useTimeZonesState } from '../state';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberBusinessHours',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const {
	businessHoursActive,
	phoneNumberDetails,
	forwardingActive,
	businessHours,
	toggleBusinessHours,
	updateBusinessHours
} = usePhoneNumberDetails();
const { timeZones, isLoading } = useTimeZonesState();
const { updatePhoneNumber } = usePhoneNumbers();
const toast = useToast();
const { loading: toggling, toggleLoading } =
	useLoading(false);
const { getDayValue, getDay } = useDays();
const {
	formData,
	fillFormData,
	isFormChanged,
	onSubmit,
	loading
} = useForm(
	{
		timezone: '',
		hours: [] as BusinessDay[],
		afterHoursVoiceMail: null
	},
	{
		timezone: {
			required
		},
		afterHoursVoiceMail: {
			required
		}
	}
);

const dialog =
	ref<
		Nullable<
			InstanceType<
				typeof EditPhoneNumberBusinessHoursDialog
			>
		>
	>(null);

const isDisabled = computed(
	() =>
		!isFormChanged({
			...phoneNumberDetails.value,
			...businessHours.value
		})
);

const triggerToggleBusinessHours = async () => {
	emit('loading', true);
	toggleLoading(true);
	await toggleBusinessHours(
		businessHoursActive.value ? 0 : 1
	).finally(() => {
		toggleLoading(false);
		emit('loading', false);
	});
	toast.success(
		`Business hours were ${
			businessHoursActive.value
				? 'activated'
				: 'deactivated'
		}.`
	);
};

const editDay = (id: number) => {
	if (
		toggling.value ||
		loading.value ||
		!businessHoursActive.value
	) {
		return;
	}
	dialog.value?.openDialog(id);
};

const fillForm = () => {
	fillFormData({
		...phoneNumberDetails.value,
		...businessHours.value
	});
};

const submit = onSubmit(async (data) => {
	emit('loading', true);
	await updateBusinessHours(data).finally(() =>
		emit('loading', false)
	);
	fillForm();
});

fillForm();

return (_ctx: any,_cache: any) => {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PhoneDetailsPanel, {
      title: "Business hours",
      subTitle: "Calls after your business hours go straight to voicemail",
      isActive: _unref(businessHoursActive),
      loading: _unref(toggling),
      disabled: _unref(toggling) || _unref(forwardingActive) || __props.disabled,
      onToggle: triggerToggleBusinessHours,
      class: _normalizeClass({
			'opacity-50 cursor-not-allowed':
				_unref(forwardingActive)
		})
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(UiForm), {
          onSubmit: _unref(submit),
          class: "relative"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_1, [
                (!_unref(isLoading))
                  ? (_openBlock(), _createBlock(_unref(UiSelect), {
                      key: 0,
                      label: "Timezone",
                      placeholder: "Select timezone",
                      novalidate: "",
                      name: "timezone",
                      disabled: 
							!_unref(businessHoursActive) ||
							_unref(loading) ||
							_unref(toggling) ||
							_unref(forwardingActive) ||
							__props.disabled
						,
                      modelValue: _unref(formData).timezone,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).timezone) = $event)),
                      options: _unref(timeZones)
                    }, null, 8, ["disabled", "modelValue", "options"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_2,
                      _hoisted_3
                    ], 64))
              ]),
              _createVNode(_unref(UiCardDivider), { title: "Schedule" }),
              _createVNode(_unref(UiCard), { class: "max-w-xs" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
							'grid gap-y-2',
							{
								'opacity-50':
									_unref(toggling) ||
									_unref(loading) ||
									!_unref(businessHoursActive) ||
									_unref(forwardingActive) ||
									__props.disabled
							}
						])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).hours, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex justify-between",
                        key: day.id
                      }, [
                        _createTextVNode(_toDisplayString(_unref(getDay)(day)) + " ", 1),
                        _createElementVNode("div", {
                          class: "underline cursor-pointer group flex items-center",
                          onClick: ($event: any) => (editDay(day.id))
                        }, [
                          _createTextVNode(_toDisplayString(_unref(getDayValue)(day)) + " ", 1),
                          _createVNode(_unref(SvgIcon), {
                            class: "ml-2 h-4 w-4 transition opacity-0 group-hover:opacity-100",
                            name: "edit"
                          })
                        ], 8, _hoisted_4)
                      ]))
                    }), 128))
                  ], 2)
                ]),
                _: 1
              }),
              _createVNode(_unref(UiCardDivider), {
                class: "mt-4",
                title: "Away voicemail greeting"
              }),
              _createVNode(_unref(UiAudio), {
                name: "afterHoursVoiceMail",
                disabled: 
						_unref(loading) ||
						_unref(forwardingActive) ||
						__props.disabled
					,
                modelValue: _unref(formData).afterHoursVoiceMail,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).afterHoursVoiceMail) = $event)),
                noRemove: ""
              }, null, 8, ["disabled", "modelValue"]),
              _createVNode(_component_ElTooltip, {
                disabled: 
						(!_unref(isDisabled) &&
							!_unref(forwardingActive)) ||
						__props.disabled
					,
                "show-after": 500,
                "hide-after": 0,
                enterable: false,
                placement: "left",
                content: "You have no changes to save"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(UiButton), {
                      class: "!h-10 !min-w-24",
                      loading: _unref(loading),
                      disabled: 
								!_unref(businessHoursActive) ||
								_unref(isDisabled) ||
								_unref(toggling) ||
								_unref(forwardingActive) ||
								__props.disabled
							
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save Changes")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    }, 8, ["isActive", "loading", "disabled", "class"]),
    _createVNode(EditPhoneNumberBusinessHoursDialog, {
      ref_key: "dialog",
      ref: dialog,
      modelValue: _unref(formData).hours,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).hours) = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})